export const SITE = {
  name: "Elentara",
  positioning: "Creative Technology Studio",
  statement: "Digital experiences beyond the expected.",
  philosophy: "Building what shouldn't exist yet.",
  serviceLine:
    "Immersive Web · Creative Technology · 3D · Spatial Computing · Interactive Systems",
  email: "workelentara@gmail.com",
  base: "https://elentara-immersive.emergent.host",
  social: [{ label: "X", href: "https://x.com/AKPADVANAVAM" }],
};

export const url = (path = "/") => `${SITE.base}${path}`;
